import React from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../ui/alert-dialog';
interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  destructive?: boolean;
}
export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
  confirmText = 'Potrdi',
  cancelText = 'Prekliči',
  destructive = false
}: ConfirmDialogProps) {
  return <AlertDialog open={open} onOpenChange={onOpenChange} data-id="element-71">
      <AlertDialogContent data-id="element-72">
        <AlertDialogHeader data-id="element-73">
          <AlertDialogTitle data-id="element-74">{title}</AlertDialogTitle>
          <AlertDialogDescription data-id="element-75">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter data-id="element-76">
          <AlertDialogCancel data-id="element-77">{cancelText}</AlertDialogCancel>
          <AlertDialogAction onClick={e => {
          e.preventDefault();
          onConfirm();
          onOpenChange(false);
        }} className={destructive ? 'bg-red-600 hover:bg-red-700 text-white' : ''} data-id="element-78">
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>;
}